(function ($) {
    "use strict";

    $(function () {
        let page = getPageFromUrl() ? parseInt(getPageFromUrl()) : 1; // Get page from pretty URL or default to 1
        let currentPage = 1; // Start from page 1

        // Automatically load all posts up to the current page number
        if (page > 1) {
            loadPostsSequentially(page);
        }

        $('.js-load-more-results').on('click', function () {
            loadMorePosts(page, false);
        });

        // Load posts for the requested page number
        function loadPostsSequentially(targetPage) {
            if (currentPage <= targetPage) {
                loadMorePosts(currentPage, true, function () {
                    if (currentPage < targetPage) {
                        currentPage++; // Increment and load the next page
                        loadPostsSequentially(targetPage);
                    } else {
                        scrollToPage(targetPage); // Scroll to the requested page's posts
                    }
                });
            }
        }

        function loadMorePosts(currentPage, isInitialLoad, callback) {
            const button = $('.js-load-more-results');
            const data = {
                action: 'load_more_news',
                page: currentPage,
                posts_per_page: localize.posts_per_page,
                nonce: localize.load_more_nonce
            };

            $.ajax({
                url: localize.ajaxurl,
                type: 'POST',
                data: data,
                beforeSend: function () {
                    if (!isInitialLoad) {
                        button.text(localize.translations.loadmore); // Change button text during loading
                    }
                },
                success: function (response) {
                    if (response.success && response.data) {
                        $('.js-more-results').append(response.data).promise().done(function () {
                            setBoxHeightOfElements(); // Ensure box heights are adjusted after appending
                        });

                        // Update the URL with the new page using pretty URLs
                        if (!isInitialLoad) {
                            page++; // Increment the page number only after manual load
                            updateUrlWithPrettyPagination(page); // Update the URL with pretty pagination
                        }

                        if (typeof callback === "function") {
                            callback(); // Call the next step in sequential loading
                        }

                        button.text(localize.translations.load_more_button_text); // Reset button text
                    } else {
                        button.text(localize.translations.no_more_text).attr('disabled', true); // No more posts
                    }
                },
                error: function () {
                    button.text('Error').attr('disabled', true); // Handle error
                }
            });
        }

        // Helper function to get page number from pretty URL
        function getPageFromUrl() {
            const path = window.location.pathname;
            const regex = new RegExp(localize.translations.pagination_slug + '\\/([0-9]+)'); // Use the localized slug
            const matches = path.match(regex);
            return matches ? matches[1] : null;
        }

        // Helper function to update URL with pretty pagination
        function updateUrlWithPrettyPagination(page) {
            const currentUrl = window.location.href;
            let newUrl = currentUrl.split(localize.translations.pagination_slug + '/')[0] + localize.translations.pagination_slug + '/' + page + '/'; // Use the localized slug
            window.history.replaceState(null, null, newUrl); // Update the URL without reloading the page
        }

        // Scroll to posts of the specified page
        function scrollToPage(targetPage) {
            const scrollTarget = $('.js-more-results > .box-grid').eq((targetPage - 1) * localize.posts_per_page); // Select the first post of the target page
            if (scrollTarget.length) {
                $('html, body').animate({
                    scrollTop: scrollTarget.offset().top
                }, 1000); // Smooth scroll to the first post of the requested page
            }
        }
    });

})(jQuery);
